import { Button } from "../../../../../catalyst-components/button";
import { Input } from "../../../../../catalyst-components/input";
import { Textarea } from "../../../../../catalyst-components/textarea";
import { MultipleChoiceQuestion } from "../../../../../shared/models";

export interface MultipleChoiceQuestionArgs {
    questions: MultipleChoiceQuestion[] | [];
    setQuestions: (questions: MultipleChoiceQuestion[]) => void;
}
export const MultipleChoiceQuestionsList = ({ questions, setQuestions }: MultipleChoiceQuestionArgs) => {
    const handleDeleteQuestion = (index: number) => {
        setQuestions(questions.filter((_, i) => i !== index));
    }

    const handleDeleteOption = (index: number, optionIndex: number) => {
        const newQuestions = [...questions];
        newQuestions[index].options.splice(optionIndex, 1);
        setQuestions(newQuestions);
    }

    const handleAddOption = (index: number) => {
        const newQuestions = [...questions];
        newQuestions[index].options.push('');
        setQuestions(newQuestions);
    }

    const handleQuestionChange = (index: number, value: string) => {
        const newQuestions = [...questions];
        newQuestions[index].question = value;
        setQuestions(newQuestions);
    }
    const handleOptionChange = (questionIndex: number, optionIndex: number, value: string) => {
        const newQuestions = [...questions];
        newQuestions[questionIndex].options[optionIndex] = value;
        setQuestions(newQuestions);
    }

    const handleAddQuestion = () => {
        setQuestions([...questions, { question: '', options: [''] }]);
    }

    const handleMoveQuestionUp = (questionIndex: number) => {
        const newQuestions = [...questions];
        const temp = newQuestions[questionIndex];
        newQuestions[questionIndex] = newQuestions[questionIndex - 1];
        newQuestions[questionIndex - 1] = temp;
        setQuestions(newQuestions);
    }   

    const handleMoveQuestionDown = (questionIndex: number) => {
        const newQuestions = [...questions];
        const temp = newQuestions[questionIndex];
        newQuestions[questionIndex] = newQuestions[questionIndex + 1];
        newQuestions[questionIndex + 1] = temp;
        setQuestions(newQuestions);
    }

    return (
        <div>
            {questions.map((question, questionIndex) => (
                <div key={questionIndex} className="mb-4">
                    <h1>Question {questionIndex + 1}:</h1>
                    <Textarea value={question.question} onChange={(e) => handleQuestionChange(questionIndex, e.target.value)} />
                    {question.options.map((option, optionIndex) => (
                        <div key={optionIndex} className="flex flex-row mt-2 space-x-2 items-center justify-between">
                            <h3>Option {optionIndex + 1}:</h3>
                            <Input key={optionIndex} value={option} onChange={(e) => handleOptionChange(questionIndex, optionIndex, e.target.value)} />
                            <Button color="light" onClick={() => handleDeleteOption(questionIndex, optionIndex)}>Delete</Button>
                        </div>
                    ))}
                    <div className="flex flex-row mt-2 space-x-2 items-center justify-between">
                        <Button color="light" onClick={() => handleAddOption(questionIndex)}>Add Option</Button>
                        <Button color="light" disabled={questionIndex === 0} onClick={() => handleMoveQuestionUp(questionIndex)}>Move up</Button>
                        <Button color="light" disabled={questionIndex === questions.length - 1} onClick={() => handleMoveQuestionDown(questionIndex)}>Move down</Button>
                        <Button color="light" onClick={() => handleDeleteQuestion(questionIndex)}>Delete Question</Button>
                    </div>
                </div>
            ))}
            <Button color="light" onClick={() => handleAddQuestion()}>Add Question</Button>     
        </div>
    );
}